import { render, staticRenderFns } from "./JointProjectIndex.vue?vue&type=template&id=70fd3748&scoped=true"
import script from "./JointProjectIndex.vue?vue&type=script&lang=js"
export * from "./JointProjectIndex.vue?vue&type=script&lang=js"
import style0 from "./JointProjectIndex.vue?vue&type=style&index=0&id=70fd3748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fd3748",
  null
  
)

export default component.exports